import { render } from "./dai.vue?vue&type=template&id=c3754dd2&scoped=true"
import script from "./dai.vue?vue&type=script&lang=js"
export * from "./dai.vue?vue&type=script&lang=js"

import "./dai.vue?vue&type=style&index=0&id=c3754dd2&scoped=true&lang=css"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3754dd2"]])

export default __exports__